export default function initVideoBanners(container = document) {
  console.log("Initializing video banners inside container:", container);
  const sections = container.querySelectorAll('[data-section-type="video-banner"]');
  console.log(`Found ${sections.length} video banner sections.`);

  sections.forEach(section => {
    const playControls = section.dataset.playControls === 'true';
    const muteControls = section.dataset.muteControls === 'true';
    const enableAutoplay = section.dataset.enableAutoplay === 'true';
    console.log(`Section dataset: playControls=${playControls}, muteControls=${muteControls}, enableAutoplay=${enableAutoplay}`);

    const wrappers = section.querySelectorAll('.component-video__wrapper');
    console.log(`Found ${wrappers.length} video wrappers inside section.`);

    wrappers.forEach((wrapper, index) => {
      const video = wrapper.querySelector('video');
      console.log(`Wrapper ${index}: video found? ${!!video}`);
      if (!video) return;

      const playBtn = wrapper.querySelector('[data-video-play]');
      const volumeBtn = wrapper.querySelector('[data-video-volume]');
      console.log(`Wrapper ${index}: playBtn found? ${!!playBtn}, volumeBtn found? ${!!volumeBtn}`);

      // Autoplay setup
      if (enableAutoplay) {
        video.setAttribute('autoplay', '');
        video.setAttribute('playsinline', '');
        video.muted = true;
        video.preload = 'auto';

        // Use IntersectionObserver to play/pause video when scrolling in/out of view
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log("Video is in viewport, playing...");
              video.play().catch(err => {
                console.warn("Autoplay play was prevented:", err);
              });
            } else {
              console.log("Video is out of viewport, pausing...");
              video.pause();
            }
          });
        }, { threshold: 0.1 });

        observer.observe(video);
      }

      // Custom play/pause controls logic
      if (playBtn) {
        playBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log(`Play button clicked. Video paused state: ${video.paused}`);

          if (video.paused) {
            video.play().catch(err => {
              console.error("Failed to play video:", err);
            });
          } else {
            video.pause();
          }
        });

        // Event listener to sync UI state
        video.addEventListener('play', () => {
          console.log("Video started playing. Updating play button class...");
          playBtn.classList.remove('video__play-control--play');
          playBtn.classList.add('video__play-control--pause');
        });

        video.addEventListener('pause', () => {
          console.log("Video paused. Updating play button class...");
          playBtn.classList.remove('video__play-control--pause');
          playBtn.classList.add('video__play-control--play');
        });
      }

      // Custom mute/unmute controls logic
      if (volumeBtn) {
        volumeBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          console.log(`Volume button clicked. Current muted state: ${video.muted}`);

          video.muted = !video.muted;
        });

        // Event listener to sync UI state
        video.addEventListener('volumechange', () => {
          console.log(`Video volume changed. Muted state: ${video.muted}. Updating volume button class...`);
          if (video.muted) {
            volumeBtn.classList.remove('video__volume-control--unmute');
            volumeBtn.classList.add('video__volume-control--mute');
          } else {
            volumeBtn.classList.remove('video__volume-control--mute');
            volumeBtn.classList.add('video__volume-control--unmute');
          }
        });
      }

      // Fallback: Click-to-play on the wrapper if custom controls are not enabled
      if (!playControls && !muteControls) {
        wrapper.style.cursor = 'pointer';
        wrapper.addEventListener('click', (e) => {
          // If click was on video element itself, browser handles it, but prevent double toggling
          if (e.target.tagName.toLowerCase() === 'video') return;
          console.log(`Wrapper clicked. Fallback play/pause toggle.`);

          if (video.paused) {
            video.play().catch(err => {
              console.error("Failed to play video:", err);
            });
          } else {
            video.pause();
          }
        });
      }
    });
  });
}

// Auto-initialize when file loads
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initVideoBanners());
} else {
  initVideoBanners();
}

// Listen to shopify section load events (in theme editor)
document.addEventListener('shopify:section:load', (event) => {
  console.log("Shopify section loaded event detected:", event.target);
  if (event.target.querySelector('[data-section-type="video-banner"]')) {
    initVideoBanners(event.target);
  }
});
